<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData
            :coaching="coachingData"
            :filtersFormated="filtersFormated"/>

        <Menu :currentUser=piniaCurrentUser
              :coaching="coachingData"/>

        <Search
            :filters="filters"
            :loading="isSearching"
            @search="getMeetingList"/>

        <div class="table-responsive overflow-auto mt-2">
          <table class="table table-striped table-hover">
            <thead>
            <tr>
              <th scope="col" style="font-size: 12px;">
                Termin
              </th>
              <th scope="col" style="font-size: 12px;">
                Anwesenheit
              </th>
              <th scope="col" class="text-end" style="font-size: 12px;">
                Startzeit
              </th>
              <th scope="col" class="text-end" style="font-size: 12px;">
                Endzeit
              </th>
              <th scope="col" class="text-end" style="font-size: 12px;">
                Einheiten
              </th>
              <th scope="col" class="text-center" style="font-size: 12px;">
                Unterschrift
              </th>
              <th scope="col" class="text-center" style="font-size: 12px;">
                Hausbesuch
              </th>
              <th scope="col" style="font-size: 12px;">
                Coach
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="meeting in meetingList" :key="meeting.id">
              <th>
                <strong>{{ meeting.date }}</strong>
              </th>
              <td>{{ capitalize(meeting.presence) }}</td>
              <td class="text-end">
                {{ meeting.startTime }}
              </td>
              <td class="text-end">
                {{ meeting.endTime }}
              </td>
              <td class="text-end">
                {{ meeting.units }}
              </td>
              <td class="text-center">
                {{ meeting.signature ? 'JA' : 'NEIN' }}
              </td>
              <td class="text-center">
                {{ meeting.homeVisit ? 'JA' : 'NEIN' }}
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ meeting?.coachFirstName }} {{ meeting?.coachLastName }}
                </strong>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import portalSocioTherapyCoachingService from '@/api/Portal/SocioTherapyCoaching';
import socioTherapyCoachingService from '@/api/Unemployed/SocioTherapyCoaching';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import { piniaUserStore } from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/SocioTherapyCoaching/CoachingOverviewData.vue';
import Search from '@/views/App/Portal/SocioTherapyCoaching/MeetingList/Search.vue';
import Menu from '@/views/App/Portal/SocioTherapyCoaching/Menu.vue';
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const piniaUserState     = piniaUserStore();
const piniaCurrentUser   = computed(() => piniaUserState?.currentUser?.user);
const route              = useRoute();
const coachingData       = ref('');
const operationType      = ref('');
const meetingList        = ref([]);
const coachingId         = +route.params.id;
const isLoaded           = ref(false);
const isDigitalSignature = ref(false);
const isSearching        = ref(false);
const coachingStartDate  = ref(null);
const coachingEndDate    = ref(null);

const filters = ref({
  startDate: '',
  endDate: '',
});

const filtersFormated = ref({
  startDate: '',
  endDate: '',
});

async function getMeetingList(passedFilters) {
  try {
    if (passedFilters) {
      isSearching.value     = true;
      filtersFormated.value = passedFilters;
    }

    const { data }    = await portalSocioTherapyCoachingService.getMeetingList(coachingId, {
      ...(passedFilters ? passedFilters : filters.value),
    });
    meetingList.value = data.data;

    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

function capitalize(value) {
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
}

async function getSocioTherapyCoachingData() {
  try {
    CloseToast();
    const { data } = await socioTherapyCoachingService.getSocioTherapyCoaching(+coachingId);

    coachingData.value       = data?.data;
    operationType.value      = data?.data?.nameOfCoaching?.operationType;
    isDigitalSignature.value = data.data.digitalSignature;

    filters.value.startDate = data.data.startDate;
    filters.value.endDate   = data.data.endDate;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await Promise.all([
    getSocioTherapyCoachingData(),
    getMeetingList(),
  ]);
  isLoaded.value = true;
});
</script>

<style scoped>

</style>